module.exports = __webpack_public_path__ + "img/campus-1.060db0de.png";